import axios from 'axios';
import { deleteToken, parseToken } from './Auth';

const API_URL = "https://upapi.gexpay.com/api" 

const API = axios.create({
  baseURL: API_URL
});

API.defaults.headers.common['X-Authorization'] = parseToken();

API.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  // Unauthorized - delete token from localStorage
  if (error.response.status === 401)
    deleteToken().then(() => {
      window.location.href = "/login";
    });

  return Promise.reject(error);
});

export default API
export { API_URL }